module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAABCAYAAAAVSWrbAAABIElEQVQoUx2PQW6TUQyEZ2wnJRCBEOqSDcuegqPlahyALYcoSJWqqEnzezzoxV7Y/kYzkgkAp5Pj6Ql8+fE7vj9/ifP5QwCveTvug3PJvu2CuCW95RW7JJQBJV3ZfS2icnQrIvNdW5GZ1lYelN0lZNoqbSobBauGSDWKo+zxzlbCLtspscxJG2l1Wih53U7AASM1TnBoMccKEjFGYJZOerVnca4fMYBsBnCX17wXaRMOx6wdHK8ocjk4ERhkKO4JHASVhpghOhQFmUuPvjOMMtiR0cloRyqBRkWHKUR0FZrMNkYV2WR1BNoI7RN9c+gh2VmLpRY3Wrn/2AduMna6vm9z/Pygl9eLvj4edDhf5t/x23z6+zZ/Hp8Hv37O6QT/B2uyxwL5heaYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xhx.png
// module id = qqXb
// module chunks = 2